<div [caLocalizationScope]="localizationScope" class="form-check form-switch form-check-inline mb-0">
  <input class="form-check-input" type="checkbox" id="surveillanceToggle" [checked]="checked" (click)="onToggle()" />
  <label class="form-check-label text-truncate" for="surveillanceToggle">{{ label | caLocalize }}</label>
</div>
